module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tpbc-bootstrap-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.processForm($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contact:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Address:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.address = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone Number:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.phone),
      expression: "form.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.phone = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Company:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.company),
      expression: "form.company"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.company = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Zip Code:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.zip),
      expression: "form.zip"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.zip = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "you@domain.com"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.email = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Book/Project Title:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.book_title),
      expression: "form.book_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.book_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.book_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.book_print),
      expression: "form.book_print"
    }],
    attrs: {
      "type": "radio",
      "value": "reprint"
    },
    domProps: {
      "checked": _vm._q(_vm.form.book_print, "reprint")
    },
    on: {
      "__c": function($event) {
        _vm.form.book_print = "reprint"
      }
    }
  }), _vm._v(" Reprint\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.book_print),
      expression: "form.book_print"
    }],
    attrs: {
      "type": "radio",
      "value": "new"
    },
    domProps: {
      "checked": _vm._q(_vm.form.book_print, "new")
    },
    on: {
      "__c": function($event) {
        _vm.form.book_print = "new"
      }
    }
  }), _vm._v(" New\n\t\t\t\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Text Provided as")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.text_provided),
      expression: "form.text_provided"
    }],
    attrs: {
      "type": "radio",
      "value": "pdf"
    },
    domProps: {
      "checked": _vm._q(_vm.form.text_provided, "pdf")
    },
    on: {
      "__c": function($event) {
        _vm.form.text_provided = "pdf"
      }
    }
  }), _vm._v(" PDF (print-ready)\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.text_provided),
      expression: "form.text_provided"
    }],
    attrs: {
      "type": "radio",
      "value": "copy-to-scan"
    },
    domProps: {
      "checked": _vm._q(_vm.form.text_provided, "copy-to-scan")
    },
    on: {
      "__c": function($event) {
        _vm.form.text_provided = "copy-to-scan"
      }
    }
  }), _vm._v(" Copy to Scan to Digital\n\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Page Count")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.page_count),
      expression: "form.page_count"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.page_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.page_count = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(option.title))]), _vm._v(" "), (option.type == 'input') ? [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text"
      }
    })] : _vm._e(), _vm._v(" "), (option.type == 'textarea') ? [_c('textarea', {
      staticClass: "form-control"
    })] : _vm._e(), _vm._v(" "), (option.type == 'select') ? _c('select', [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Please select")]), _vm._v(" "), _vm._l((_vm.getFields(option.id)), function(field) {
      return _c('option', {
        domProps: {
          "value": field.id
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(field.title) + "\n\t\t\t\t\t\t\t\t\t")])
    })], 2) : _vm._e()], 2)
  }))]), _vm._v(" "), _vm._m(0)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74932b97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form.vue
// module id = 21
// module chunks = 1